import React from 'react';
import i18next from 'i18next';
import { QuerySuggestion, QuerySuggestionResponse } from '../../@types/QuerySuggestion';
import SuggestionItem from './SuggestionItem';

interface SuggestionListProps {
  querySuggestion?: QuerySuggestionResponse;
  onSelectSuggestion: (suggestion: QuerySuggestion) => void;
  onShowAll?: () => void;
  currentIndex?: number;
}

const SuggestionList = ({
  querySuggestion,
  currentIndex,
  onSelectSuggestion,
  onShowAll,
}: SuggestionListProps) => {
  if (!querySuggestion?.suggestions.length) {
    return null;
  }

  return (
    <div className="search__foldout">
      <div className="container">
        <div className="search__foldout-label">{i18next.t('searchBar.searchResults')}</div>
        <ul className="search__foldout-list" role="listbox" aria-label={i18next.t('searchBar.searchResults') || ''}>
          {querySuggestion.suggestions.map((suggestion, index) => (
            <SuggestionItem
              key={index}
              suggestion={suggestion}
              onSelectSuggestion={onSelectSuggestion}
              active={currentIndex === index}
            />
          ))}
        </ul>
        {onShowAll && (
          <div className="search__foldout-action">
            <button className="button button--primary" title="" onClick={onShowAll}>
              <span className="button__content">{i18next.t('searchBar.showAllRsults')}</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SuggestionList;
